import React,{Fragment, useState, useEffect} from 'react';
import Formulario from './components/Formulario';
import Cita from './components/Cita';


function App() {


  let citasIniciales = JSON.parse(localStorage.getItem('citas'));
  if(!citasIniciales){
    citasIniciales = [];
  }

  //arreglo de citas
  const [citas, guardarCitas] = useState(citasIniciales);

  //useEffect
  useEffect(() => {
    if(citasIniciales){
      localStorage.setItem('citas', JSON.stringify(citas))
    } else {
      localStorage.setItem('citas', JSON.stringify([]));
    }
    
  }, [citas, citasIniciales]);


  //creo una funcion que tome las citas actuales y tome la nueva

  const crearCita = cita =>{
    guardarCitas([
      ...citas, 
      cita
    ])
    console.log(cita)

  }

  //funcion que elimina una cita por su id
  const eliminarCita = id => {
    //creo nuevo arreglo que va a ser el que crea filter, sin esa cita q ya elimine
    //y al usar filter, tengo q buscar el distinto, para q filter cree uno nuevo con los dos que quedaron. Por que si no, lo hace al reves
    const nuevasCitas =citas.filter(cita=> cita.id !==id);

    guardarCitas(nuevasCitas);
  }

  //mensaje condicional
  const titulo = citas.length === 0 ? 'No hay citas' : 'Administra tus citas'
  

  return (
    <Fragment>
    
    <h1>Administrador de pacientes</h1>
    <div className="container">
      <div className="row">
        <div className="one-half column">
          <Formulario
            crearCita={crearCita}
          />
         </div>
         <div className="one-half column">
          <h2>{titulo}</h2>
          {citas.map(cita => (
            <Cita 
              key={cita.id}
              cita={cita}
              eliminarCita={eliminarCita}
            />
          ))}
          
         </div>
        </div>
      </div>
  </Fragment>
  );
}

export default App;
